export class SocialShareController {

  private readonly facebookShares = document.querySelectorAll('.js-shareLink-facebook');
  private readonly twitterShares = document.querySelectorAll('.js-shareLink-twitter');
  private readonly linkedinShares = document.querySelectorAll('.js-shareLink-linkedin');
  private readonly xingShares = document.querySelectorAll('.js-shareLink-xing');

  constructor() {
    this.facebookShares.forEach((facebook: HTMLElement) => {
      facebook.addEventListener(
        'click', (event) => {
          event.preventDefault();
          window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + window.location,
            'facebookwindow',
            'height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,'
              + ', top=' + (getHalfHeight() - 225) + ', left=' + (getHalfWidth() - 300),
          );
          return false;
        },
      );
    });

    this.twitterShares.forEach((twitter: HTMLElement) => {
      twitter.addEventListener(
        'click', (event) => {
          event.preventDefault();
          window.open(
            'https://twitter.com/share?url=' + window.location + '&text=' + encodeURIComponent(document.title),
            'twitterwindow',
            'height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0,'
              + ', top=' + (getHalfHeight() - 225) + ', left=' + (getHalfWidth() - 300),
          );
          return false;
        },
      );
    });

    this.linkedinShares.forEach((linkedin: HTMLElement) => {
      linkedin.addEventListener(
        'click', (event) => {
          event.preventDefault();
          window.open(
            'https://www.linkedin.com/shareArticle?mini=true&url=' + window.location + '&title=' + encodeURIComponent(document.title),
            'linkedinwindow',
            'height=500, width=600, toolbar=0, location=0, menubar=0, status=1, scrollbars=1, resizable=1'
              + ', top=' + (getHalfHeight() - 250) + ', left=' + (getHalfWidth() - 300),
          );
          return false;
        },
      );
    });

    this.xingShares.forEach((xing: HTMLElement) => {
      xing.addEventListener(
        'click', (event) => {
          event.preventDefault();
          window.open(
            'https://www.xing.com/spi/shares/new?url=' + window.location,
            'xingwindow',
            'height=500, width=600, toolbar=0, location=0, menubar=0, status=1, scrollbars=1, resizable=1'
              + ', top=' + (getHalfHeight() - 250) + ', left=' + (getHalfWidth() - 300),
          );
          return false;
        },
      );
    });

  }
}

function getHalfHeight() {
  return (window.innerHeight / 2) + window.screenY;
}

function getHalfWidth() {
  return (window.innerWidth / 2) + window.screenX;
}
